import React from "react";
import { Form, Input } from "antd";
import { useState } from "react";
import toast from "react-hot-toast";
import { SendemailApi } from "../../api/request/users";
import { useNavigate } from "react-router-dom";
import LoadableButton from "../../components/buttons/LoadableButton.jsx";
import Message from "../../assets/auth/Message.jsx";
import { useResponsive } from "../../hooks/useResponsive.js";

function ForgetPassword() {
  const { isMobile } = useResponsive();
  const navigate = useNavigate();
  // const { broker } = useSelector((state) => state.broker);
  const [isLoading, setIsLoading] = useState(false);
  const [FormData, setFormData] = useState({ email: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email } = FormData;
    if (!email) {
      toast.error("Email can not be empty.");
      return;
    }
    try {
      setIsLoading(true);
      let params = {
        email: FormData?.email,
        // userType: 0
      };
      const { data } = await SendemailApi(params);

      if (data?.success) {
        toast.success(data?.message);
        // localStorage.setItem("email", FormData?.email);
        localStorage.setItem('email', JSON.stringify(FormData?.email));
        navigate("/password_otp_verification");
      } else {
        toast.error(data.message || "An error occurred.");
      }
      setIsLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.error?.message || "An error occurred.");
      // setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      {!isMobile ? <div className='flex items-center justify-center min-h-screen bg-[#f9f9f9] auth-bg'>
        <div className='w-full max-w-md bg-white p-10 rounded-2xl shadow-xl'>
          <div className="flex justify-center mb-6">
            <img src='/assets/logo/logo.png' alt='logo' className='h-20 w-48 object-contain ' />
          </div>

          <div className="w-full">
            <form autoComplete="off" onSubmit={handleSubmit}>
              <div className="w-full text-sm py-1 ">
                <p className="text-[#585F70] font-semibold ">Email</p>
                <div className="relative">
                  <Form.Item
                    type="email"
                    name="email"
                    className="transperant-input"
                    rules={[
                      {
                        required: true,
                        message: "Please enter email id.",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Email-id"
                      className="border rounded-lg w-full ps-4 py-2"
                      prefix={
                        <Message />
                      }
                      value={FormData.email}
                      name="email"
                      onChange={handleChange}
                    />
                  </Form.Item>
                </div>
              </div>

              <div className="mt-4">
                <LoadableButton type='submit' className='bg-primary text-[#FFFFFF] font-semibold text-lg rounded-lg w-full py-2 text' lable='Send Code' isLoading={isLoading} loadingLable='Sending Code...' />
              </div>
              <div className="primary flex items-center justify-center mt-5 text-sm">
                <a href="/" className="underline">Back to login</a>
              </div>
            </form>
          </div>
        </div>
      </div> : <div className='bg-blue-50 h-svh mobile-dashboard'>
        <div className='p-5 pt-10'>
          <div className="flex justify-center mb-8">
            <img src='/assets/logo/logo.png' alt='logo' className='h-14 w-48 object-contain ' />
          </div>
          <div className="w-full">
            <div className="my-5 mt-10">
              <p className="text-xl font-bold mb-2 text-dark-200">Forgot Password</p>
              <p className="text-gray-500">Please Enter Your Email Address</p>
            </div>
            <form autoComplete="off" onSubmit={handleSubmit}>
              <div className="w-full text-sm py-1 ">
                <div className="relative">
                  <Form.Item
                    type="email"
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Your Email ID.",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter your email-id"
                      className="border border-slate-200 rounded-[14px] w-full ps-3 py-3"
                      value={FormData.email}
                      name="email"
                      onChange={handleChange}
                    />
                  </Form.Item>
                </div>
              </div>

              <div className="mt-4">
                <LoadableButton type='submit' className='bg-primary-mobile text-[#FFFFFF] font-semibold text-lg rounded-[14px] w-full py-3 text' lable='Send Code' isLoading={isLoading} loadingLable='Sending Code...' />
              </div>
              <div className="primary flex items-center justify-center mt-5 text-sm">
                <a href="/" className="underline">Back to login</a>
              </div>
            </form>
          </div>
        </div>
      </div>}
    </>
  );
}
export default ForgetPassword;
